import { Sequence } from "@twii/common/lib/Id";
var ComponentIdSequence = new Sequence("db-comp-");
export { ComponentIdSequence };
